//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "Hepatitis_B_five",
  data() {
    return {
      form: {
        HBsAg: "",
        HBsAb: "",
        HBeAg: "",
        HBeAb: "",
        HBcAb:'',
      },
      hasScore: false,
      disabled: false,
      dataList: [
        { value: "0", name: "阴性" },
        { value: "1", name: "阳性" },
      ],
      referObj:{
        '00000':"未感染过乙肝，对乙肝病毒没有免疫力",
        '01000':"理想状态，表示乙肝疫苗接种成功，或者感染乙肝康复具有免疫力",
        '10000':'因为 HBsAg 最早出现提示感染潜伏期后期或携带者，但是 HBeAg 阴性提示感染性不强',
        '00100':'HBsAg 阴性不能完全排除乙肝、单独 HBeAg 阳性提示乙肝非典型急性感染，但是很少有 HBeAg 单独阳性者',
        '00010':'一般 HBeAg 阴转后才会出现 HBeAb，所以提示感染趋向恢复，一般无传染性',
        '00001':'HBcAg 抗原性很强，但是检不出，所以 HBcAb 阳性提示 HBcAg 的存在，表示感染很早期，或者既往感染过后恢复期',
        '11000':'一般情况只有 HBsAg 消失以后才会出现 HBsAb，但是可见于乙肝病毒亚临床感染早期，病毒和抗体共存，或者不同亚型 HBV 二次感染等比较少见的情况',
        '10100':'大二阳，HBsAg 提示感染，病毒复制活跃，传染性强',
        '10010':'急性感染趋向恢复、传染性弱',
        '10001':'小二阳，恢复期、传染性弱，长期持续易癌变',
        '01100':'非典型肝炎',
        '01010':"感染已恢复",
        '01001':'恢二阳，乙肝恢复期，已有免疫力',
        '00101':"乙肝病毒非典型急性感染",
        '00011':'既往感染，急性乙肝恢复期，基本无传染性',
        '10101':'大三阳，存在感染且病毒复制活跃',
        '10011':'小三阳，恢复期、传染性弱、长期持续易癌变',
        '01011':'恢三阳，乙肝恢复期，已有免疫力',
        '11001':'乙肝病毒亚临床感染早期、或不同亚型 HBV 感染',
        '11010':'乙肝病毒亚临床感染或非典型肝炎',
        '00111':'急性乙肝病毒感染中期',
        '01101':'乙型肝炎病毒亚临床感染或非典型肝炎',
        '10111':'急性乙肝感染趋向恢复，或者为慢性乙肝病毒携带者',
        '11101':"乙肝病毒亚临床感染或非典型肝炎"
      },
      infoText:''
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      console.log('计算');
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      let result = '';
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
        result =result + Number(form[key]);
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        self.hasScore = true;
        for (const o in this.referObj) {
          if(result == o) {
            this.infoText = this.referObj[o]
          } 
        }
        return this.infoText;
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Hepatitis_B_five.vue